import { render, staticRenderFns } from "./DeleteTask.vue?vue&type=template&id=2cadc168&scoped=true&lang=pug&"
import script from "./DeleteTask.vue?vue&type=script&lang=js&"
export * from "./DeleteTask.vue?vue&type=script&lang=js&"
import style0 from "./DeleteTask.vue?vue&type=style&index=0&id=2cadc168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cadc168",
  null
  
)

export default component.exports